import { Stack, styled } from '@mui/material';

// ------------------------------------------------------------

export const CustomMain = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 50,
  alignItems: 'center',
  flexWrap: 'wrap',
  justifyContent: 'center',
}));

export const CustomInfo = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '20px',
  alignItems: 'center',
}));
